import { Component, OnInit, Input } from '@angular/core';
import { Mode } from 'src/modules/shared/form-guide/utility/enums/enums';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {


  @Input() mode: Mode  ;
  @Input() showH4: boolean ;
  @Input() message: string;
  
  enumMode = Mode;
  

  
  constructor() { }

  ngOnInit() {
  }

}
